import React, { memo } from "react";
import { Switch as MUISwitch, SwitchProps } from "@mui/material";

const Switch: React.FC<SwitchProps> = (props) => {
  return <MUISwitch {...props} />;
};

export default memo(Switch);
